<app-header></app-header>

<section class="container-xxl">
<!-- BREADCRUMB AREA - STARTS -->
<div class="breadcrumb-area">
<nav aria-label="breadcrumb mb-0">
<ol class="breadcrumb">
<li class="breadcrumb-item"><a routerLink="/" [attr.title]="language=='English'?'Home':'होम'" class="screen-reader">{{'Home' | translate }}</a></li>
<li class="breadcrumb-item active screen-reader">{{ language=='English'?"Site Map":"साइट मानचित्र" }}</li>

</ol>
</nav>
</div>
<!-- BREADCRUMB AREA - ENDS -->

<div class="inner-page">
<div class="inner-page-details">
<div class="row">
<div class="col-lg-12">
<!-- INNER CONTENT - STARTS -->
<div class="inner-page-sidedetails">
<div class="row">
<div class="col-lg-12">
<div id="section-New"></div>
<div class="inner-banner-image">
<div class="image-area">
<img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
</div>
</div>
<div class="details mb-4">
<div class="title">
<h2 class="screen-reader">{{ language=='English'?"Site Map":"साइट मानचित्र" }}</h2>
</div>
<div class="description">
<div class="sitemap-area">
<div class="row">
<div class="col-lg-12">
<!-- sitemap section area -->
<div class="sitemap border-none">


    <div class="row scroll-mob">
        <div class="col-xl-7">
            <div class="branch bs1 lf-gap">
                <div class="entry " *ngFor="let loopGlobalHeader of headerGlobalMenu"> 
                    
            <!-- End of External Page  -->
            <a *ngIf='loopGlobalHeader["linkType"]==1' (click)='goToExtLink(loopGlobalHeader["externalLink"])' href="javascript:;"  title='{{ htmldecode(loopGlobalHeader["menuNameInEnglish"]) }}'
            class="screen-reader fx-width"> <span class="label"> 
            {{ htmldecode(language=='English'?loopGlobalHeader["menuNameInEnglish"]:loopGlobalHeader["menuNameInHindi"]) }} </span> </a>                
                        
 
            <!-- For Plugin Page-->
            <a *ngIf='loopGlobalHeader["linkType"]==2' class="fx-width screen-reader" 
            (click)="goToPluginPage(loopGlobalHeader['selectPlugin'],{'plugin_id':loopGlobalHeader['id'],'selectPlugin':loopGlobalHeader['selectPlugin']})"
            ><span class="label">{{ htmldecode(language=='English'?loopGlobalHeader["menuNameInEnglish"]:loopGlobalHeader["menuNameInHindi"]) }} </span> </a>
            <!-- End of Plugin Page  -->

            <!-- For Content Page-->
            <a *ngIf='loopGlobalHeader["linkType"]==3' class="fx-width screen-reader" href="javascript:void();"
            (click)="goToContentPage(loopGlobalHeader)">
            <span class="label btn btn-success"> {{ htmldecode(language=='English'?loopGlobalHeader["menuNameInEnglish"]:loopGlobalHeader["menuNameInHindi"]) }}  </span> </a>
            <!-- End of Content Page  -->

            <!-- For NA -->
            <a *ngIf='loopGlobalHeader["linkType"]==4' class="fx-width screen-reader" href="javascript:void();"
            > <span class="label btn btn-success"> {{ htmldecode(language=='English'?loopGlobalHeader["menuNameInEnglish"]:loopGlobalHeader["menuNameInHindi"]) }} </span> </a>



                    <div class="branch bs2" *ngIf='loopGlobalHeader["linkType"]==4'>

                        <ng-container  *ngFor="let loopPrimaryHeader of headerPrimaryMenu"> 

                            <div class="entry" *ngIf='loopGlobalHeader["id"] == loopPrimaryHeader["globalMenu"]'>

                                <!-- For External Page-->
                                <a class="screen-reader" *ngIf='loopPrimaryHeader["linkType"] ==1' href="javascript:void();"  (click)='goToExtLink(loopPrimaryHeader["externalLink"])' title='{{htmldecode(loopPrimaryHeader["menuNameInEnglish"])}}'>
                                    <span class="label">{{htmldecode(language=='English'?loopPrimaryHeader["menuNameInEnglish"]:loopPrimaryHeader["menuNameInHindi"])}}</span> 
                                </a>

                                 <!-- For Plugin Page-->
                                 <a class="screen-reader" *ngIf='loopPrimaryHeader["linkType"] ==2' href="javascript:void();" [routerLink]='"/"+loopPrimaryHeader["selectPlugin"]' title='{{htmldecode(loopPrimaryHeader["menuNameInEnglish"])}}'>
                                    <span class="label">{{htmldecode(language=='English'?loopPrimaryHeader["menuNameInEnglish"]:loopPrimaryHeader["menuNameInHindi"])}}</span> 
                                </a>
                                <!-- End of Plugin Page  -->


                                <!-- For Content Page-->


                    <a class="screen-reader" *ngIf='loopPrimaryHeader["linkType"] ==3' href="javascript:void();" (click)="goToContentPage(loopPrimaryHeader)"  title='{{htmldecode(loopPrimaryHeader["menuNameInEnglish"])}}'>
                        <span class="label">{{htmldecode(language=='English'?loopPrimaryHeader["menuNameInEnglish"]:loopPrimaryHeader["menuNameInHindi"])}}</span> 
                    </a>


                            </div>
                           
                        </ng-container>

                      
                    </div>
         </div>
            </div>
        </div>


        <div class="col-xl-5">
            <div *ngFor="let loopGlobalFooter of footerGlobalMenu">
            <h4 class="screen-reader"> {{htmldecode(language=='English'?loopGlobalFooter["menuNameInEnglish"]:loopGlobalFooter["menuNameInHindi"])}} </h4>

            <div class="branch bs1 rf-gap mb-3">
                <ng-container *ngFor="let loopPrimaryFooter of footerPrimaryMenu">
    
                    <div class="entry" *ngIf='loopGlobalFooter["id"] == loopPrimaryFooter["globalMenu"]'>
                     
                         <!-- For External Page-->
                         <a class="screen-reader" *ngIf='loopPrimaryFooter["linkType"] ==1' href="javascript:void();"
                         [title]='loopPrimaryFooter["menuNameInEnglish"]'
                         (click)='goToExtLink(loopPrimaryFooter["externalLink"])' title='{{loopPrimaryFooter["menuNameInEnglish"]}}'><span class="label">{{htmldecode(language=='English'?loopPrimaryFooter["menuNameInEnglish"]:loopPrimaryFooter["menuNameInHindi"])}}</span></a>
                     <!-- End of External Page  -->
                     
                     <!-- For Plugin Page-->
                     <a class="screen-reader" *ngIf='loopPrimaryFooter["linkType"] ==2' 
                        href="javascript:void(0);"
                        (click)="goToPluginPage(loopPrimaryFooter['selectPlugin'],{'plugin_id':loopPrimaryFooter['id'],'selectPlugin':loopPrimaryFooter['selectPlugin']})"
                         [title]='loopPrimaryFooter["menuNameInEnglish"]'
                         title='{{loopPrimaryFooter["menuNameInEnglish"]}}'><span class="label">
                            {{ htmldecode(language=='English'?loopPrimaryFooter["menuNameInEnglish"]:loopPrimaryFooter["menuNameInHindi"]) }}
                        </span></a>
                     <!-- End of Plugin Page  -->
    
                     <!-- For Content Page-->
    
                     <a class="screen-reader" *ngIf='loopPrimaryFooter["linkType"] ==3' href="javascript:void();"
                         [title]='loopPrimaryFooter["menuNameInEnglish"]'
                         (click)="goToContentPage(loopPrimaryFooter)" title='{{loopPrimaryFooter["menuNameInEnglish"]}}'><span class="label">{{htmldecode(language=='English'?loopPrimaryFooter["menuNameInEnglish"]:loopPrimaryFooter["menuNameInHindi"])}}</span></a>
    
                    </div>
                   
    
                  
    
                </ng-container>
            </div>
        </div>
        </div>

    </div>



</div>
<!-- sitemap section area -->
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<!-- INNER CONTENT - ENDS -->
</div>
</div>
</div>
</div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>